var _rect, _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 40,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 196,
    r: 171,
    fill: "#232021",
    stroke: "#65A2FD",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.033 77.4692L352.235 179.671C361.998 189.434 361.998 205.263 352.235 215.026L319.116 248.145L199.237 128.265L250.033 77.4692Z",
    fill: "#65A2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.266 144.122L233.062 194.919L182.266 245.715L145.612 209.061C137.801 201.25 137.801 188.587 145.612 180.776L182.266 144.122Z",
    fill: "#FEFEFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.229 210.212L302.025 261.008L265.371 297.663C257.561 305.473 244.897 305.473 237.087 297.663L200.433 261.008L251.229 210.212Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.636 408.455H183.364L199.182 447.091H199.727L215.545 408.455H222.273V455H217V419.636H216.545L202 455H196.909L182.364 419.636H181.909V455H176.636V408.455ZM233.574 408.455H240.301L256.119 447.091H256.665L272.483 408.455H279.21V455H273.938V419.636H273.483L258.938 455H253.847L239.301 419.636H238.847V455H233.574V408.455ZM287.966 413.455V408.455H322.875V413.455H308.239V455H302.602V413.455H287.966Z",
    fill: "#65A2FD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b0e70a18516ec88060b02d2cea29e71f.svg";
export { ForwardRef as ReactComponent };